import(/* webpackMode: "eager" */ "/vercel/path0/app/resume/page.tsx");
